import './Badge.css'

export function Badge({ tone = 'neutral', children, style, ...rest }) {
  return (
    <span className={'u-badge u-badge--' + tone} style={style} {...rest}>
      {children}
    </span>
  )
}

export default Badge
